<template>
  <v-list dense>
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>Bundle X for Y</v-list-item-title>
        <v-list-item-subtitle>Free Quantity: {{ promoItem.quantity }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
export default {
  name: 'X4y',
  props: {
    promoItem: { type: Object, required: true },
  },
}
</script>